import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import ExploreActions from 'src/components/Explore/Actions'
import Footer from 'src/components/Footer'
import InitiativeListDeprecate from 'src/components/Initiative/ListDeprecate'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'

// =======================================================
// Layout
// =======================================================

const FuseExploreLayout = ({ children }) => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()
   const { currentUserCanEdit, exploreDescription } = organization

   return (
      <View
         position="relative"
         float="left"
         width="100%"
         paddingTop={theme.viewportMarginTop}
         paddingLeft={theme.viewportMarginLeft}
         paddingRight={theme.viewportMarginRight}>
         <Theme
            globalNavBackgroundColor="#000"
            globalNavBorderColor="#222"
            globalNavDividerColor="#333"
            globalNavLogoFieldName="logoDefaultNegative"
            globalNavTextColor="#888"
         />
         <View
            display="flex"
            justifyContent="center"
            float="left"
            width="100%"
            backgroundColor="#000">
            <View
               width="100%"
               textAlign="center"
               maxWidth={theme.viewportContentMaxWidth}
               paddingVertical={theme.viewportPaddingTop}
               paddingLeft={theme.viewportPaddingLeft}
               paddingRight={theme.viewportPaddingRight}>
               <Text
                  color="#fff"
                  letterSpacing="-0.25px"
                  size="7.5[a] 8[b] 9[c] 9[d] 10[e] 10[f]"
                  weight="medium">
                  Explore
               </Text>
               <View
                  float="left"
                  width="100%"
                  height="6px[a] 9px[b-d] 12px[e-f]"
               />
               <Text
                  color="#aaa"
                  size="2[a-b] 2.5[c] 3[d] 3.5[e-f]"
                  lineHeight="130%">
                  {exploreDescription}
               </Text>
            </View>
         </View>
         <View
            display="flex"
            justifyContent="center"
            float="left"
            minHeight="70vh"
            width="100%"
            borderTop="1px solid #eee"
            backgroundColor="#f3f3f3">
            <View
               width="100%"
               maxWidth={theme.viewportContentMaxWidth}
               paddingTop={theme.viewportPaddingTop}
               paddingLeft={theme.viewportPaddingLeft}
               paddingRight={theme.viewportPaddingRight}
               paddingBottom={theme.viewportPaddingBottom}>
               <InitiativeListDeprecate
                  cardFormat="grid"
                  gridColumns="2[a] 3[b] 4[c] 5[d] 6[e] 6[f]"
               />
            </View>
         </View>
         {currentUserCanEdit && <ExploreActions />}
         <Footer backgroundColor="#000" textColor="#666" />
      </View>
   )
}

// =======================================================
// Props
// =======================================================

FuseExploreLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default FuseExploreLayout
